exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-container[data-v-2c3fac5c]{border:1px solid;border-color:#ccc!important;border-radius:.5rem!important;overflow:hidden}[data-v-2c3fac5c] .v-datatable.v-table>thead tr{background-color:#ddd;height:40px}[data-v-2c3fac5c] .table-full .v-datatable.v-table>tbody{max-height:calc(109vh - 426px);min-height:calc(109vh - 426px)}[data-v-2c3fac5c] .table-full1 .v-datatable.v-table>tbody{max-height:calc(90vh - 426px);min-height:calc(90vh - 426px)}", ""]);

// exports
